import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledFeelStressed = {
  Title: styled.h1`
    margin: 40px 0;
    font-weight: 500;
    font-size: 24px;
    line-height: 33px;
    color: ${Color.WHITE};
  `,
}
